<template>
  <div class="main-login">
    <my-header :page_name="$t('signin.pageName')"></my-header>

    <!-- <el-alert :title="$t('signin.alert')" type="warning"></el-alert> -->

    <el-form :model="userData" ref="userForm" :rules="userRules">
      <h3 class="login-title">{{$t("signin.title")}}</h3>
      <el-form-item :label="$t('signin.userForm.username.placeholder')" prop="username"  name="username">
        <el-input v-model="userData.username"  id="username"></el-input>
      </el-form-item>
      <el-form-item :label="$t('signin.userForm.password.placeholder')" prop="password" name="password">
        <el-input v-model="userData.password" show-password @keypress.native.enter="onButtonClick" id="password"></el-input>
      </el-form-item>
      <el-form-item :label="$t('signin.userForm.language.placeholder')" v-if="languageShow" prop="language" name="language">
        <el-select v-model="userData.language" clearable filterable  id="language">
          <el-option
            v-for="item in getConfig.languages"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('signin.userForm.connection.placeholder')" v-if="connectionShow" prop="connection" name="connection">
        <el-select v-model="userData.connection" clearable filterable id="connection">
          <el-option
            v-for="item in getConfig.connections"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-button @click="onButtonClick">{{$t('signin.userForm.signin')}}</el-button>
    </el-form>
  </div>
</template> 

<script>
import Header from "../components/reusable/header/Header";
import { mapGetters } from "vuex";
export default {
  name: "Login",
  components: {
    myHeader: Header,
  },
  data() {
    return {
      userData: {
        username: null,
        password: null,
        language: null,
        connection: null,
      },
      languageShow: true,
      connectionShow: true,
      userRules: {
        username: [
          {
            required: true,
            message: this.$t("general.errorMessages.login.noUsername"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("general.errorMessages.login.noPassword"),
            trigger: "blur",
          },
        ],
        language: [
          {
            required: true,
            message: this.$t("general.errorMessages.login.noLanguage"),
            trigger: "blur",
          },
        ],
        connection: [
          {
            required: true,
            message: this.$t("general.errorMessages.login.noConnection"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    let fillLanguage = "";
    fillLanguage = this.getConfig.languages[0].value;
    this.$i18n.locale = fillLanguage === "uk" ? "ua" : fillLanguage;
    if (this.getConfig.languages.length === 1) {
      this.languageShow = false;
    }
    let fillConnection = "";
    if (this.getConfig.connections.length === 1) {
      fillConnection = this.getConfig.connections[0].value;
      this.connectionShow = false;
    }
    const savedConnection = this.$localStorage.get("wa-connection");
    if (savedConnection) {
      const connect = JSON.parse(savedConnection);
      this.userData.username = connect.login || "";
      this.userData.language = fillLanguage;
      this.userData.connection = connect.connection || fillConnection;
    } else {
      this.userData.username = "";
      this.userData.language = fillLanguage;
      this.userData.connection = fillConnection;
    }
  },
  methods: {
    onButtonClick() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          this.$store.dispatch("signIn", this.userData);
        }
      });
    },
  },
  computed: {
    ...mapGetters(["getConfig"]),
  },
};
</script>


<style scoped>
.el-alert {
  margin: 2px;
}
.main-login {
  background: var(--main-background);
  height: calc(100vh - var(--header-height) - 9.5px);
  overflow-x: hidden;
  overflow-y: hidden;
}

.el-form {
  max-width: 450px;
  margin: auto;
  margin-top: 20vh;
  background: var(--header-color);
  padding: 1em 2em 3em;
  border-radius: 10px;
}

.el-button {
  width: 100%;
}
.login-title {
  font-weight: 400;
  font-size: 2.5em;
  text-align: center;
}
</style>